import _toConsumableArray from 'babel-runtime/helpers/toConsumableArray';
import _defineProperty from 'babel-runtime/helpers/defineProperty';
import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import React, { lazy, Suspense, useState, useReducer, useEffect } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

import ProductHeader from '../../components/ProductHeader/ProductHeader';
import ProductGallery from '../../components/ProductGallery/ProductGallery';
import VirtualGiftCardProductVariantSelector from '../../components/VirtualGiftCardProductVariantSelector/VirtualGiftCardProductVariantSelector';
import ProductMessaging from '../../components/ProductMessaging/ProductMessaging';
import ProductDiscountSnippet from '../../components/ProductDiscountSnippet/ProductDiscountSnippet';
import AddToCartBtn from '../../components/AddToCartBtn/AddToCartBtn';
import KlarnaPlacement from '../../components/KlarnaPlacement/KlarnaPlacement';
import ProductAccordion from '../../components/ProductAccordion/ProductAccordion';
import ProductAddOnList from '../../components/ProductAddOnList/ProductAddOnList';
import ProductAddOnModal from '../../components/ProductAddOnModal/ProductAddOnModal';
import ProductAddOnListModal from '../../components/ProductAddOnListModal/ProductAddOnListModal';

import useFetch from '../../hooks/useFetch';
import useSelectedVariant from '../../hooks/useSelectedVariant';

import { StyledWrapper, StyledGrid, DetailsGridDiv, StyledSliderWrapper } from './VirtualGiftCardProductStyles';
import VirtualGiftCardProductForm from '../../components/VirtualGiftCardProductForm/VirtualGiftCardProductForm';

var DySlider = lazy(function () {
  return import('../../components/DySlider/DySlider');
});

var _ref = React.createElement(
  'div',
  null,
  'Loading...'
);

var _ref2 = React.createElement(
  'div',
  null,
  'Loading...'
);

var _ref3 = React.createElement('div', { id: 'product-double-billboard' });

var _ref4 = React.createElement(
  'div',
  null,
  'Loading...'
);

var VirtualGiftCardProduct = function VirtualGiftCardProduct(props) {
  var product = props.product;


  var variantInventoryData = useFetch('/products/' + props.product.handle + '?view=variant-inventory');

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      atcClicked = _useState2[0],
      setAtcClicked = _useState2[1];

  var _useSelectedVariant = useSelectedVariant(props.product),
      _useSelectedVariant2 = _slicedToArray(_useSelectedVariant, 3),
      selected = _useSelectedVariant2[0],
      handleOptionChange = _useSelectedVariant2[1],
      variantExists = _useSelectedVariant2[2];

  // Hide Liquid Product loading state when loaded


  useEffect(function () {
    var liquidProd = document.getElementById('liquid-product');
    liquidProd.style.display = 'none';
  }, []);

  // Add only one gift Card
  var selectedVariantQuantity = 1;

  var addOnModalTag = product.tags.find(function (tag) {
    return tag.includes('data--add_on:duvet-insert');
  });

  var addOnListTag = product.tags.find(function (tag) {
    return tag.includes('data--add_on:duvet-list');
  });

  // Virtual Gift Card select handler

  var _useState3 = useState('recipient'),
      _useState4 = _slicedToArray(_useState3, 2),
      selectOption = _useState4[0],
      setSelectOption = _useState4[1];

  // Virtual Gift Card input handler


  var _useReducer = useReducer(function (state, newState) {
    return Object.assign({}, state, newState);
  }, {
    sName: '',
    sEmail: '',
    rName: '',
    rEmail: '',
    message: ''
  }),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      userInput = _useReducer2[0],
      setUserInput = _useReducer2[1];

  var handleChange = function handleChange(evt) {
    var name = evt.target.name;
    var newValue = evt.target.value;
    setUserInput(_defineProperty({}, name, newValue));
  };

  // Virtual Gift Card Validation / Error Handling

  var _useReducer3 = useReducer(function (state, newState) {
    return Object.assign({}, state, newState);
  }, {
    sName: false,
    sEmail: false,
    rName: false,
    rEmail: false
  }),
      _useReducer4 = _slicedToArray(_useReducer3, 2),
      virtualGiftCardError = _useReducer4[0],
      setVirtualGiftCardError = _useReducer4[1];

  var handleVirtualGiftCardError = function handleVirtualGiftCardError(name, errorState) {
    setVirtualGiftCardError(_defineProperty({}, name, errorState));
  };

  // Reset to initial state after adding to cart
  // or switching between Self/Shared gift card.
  var setInitialStateVirtualGiftCardForm = function setInitialStateVirtualGiftCardForm() {
    setUserInput({
      sName: '',
      sEmail: '',
      rName: '',
      rEmail: '',
      message: ''
    });
    setVirtualGiftCardError({
      sName: false,
      sEmail: false,
      rName: false,
      rEmail: false
    });
  };

  // Sets to initial state switching between self/shared.
  useEffect(function () {
    setInitialStateVirtualGiftCardForm();
  }, [selectOption]);

  // Keeps track of add on items (for duvet covers)

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      addOnListSelectedItems = _useState6[0],
      setAddOnListSelectedItems = _useState6[1];

  var handleSetAddOnListSelectedItems = function handleSetAddOnListSelectedItems(product) {
    var selectedItems = [].concat(_toConsumableArray(addOnListSelectedItems));
    if (selectedItems.includes(product)) {
      selectedItems = selectedItems.filter(function (currentProduct) {
        return currentProduct !== product;
      });
    } else {
      selectedItems = [].concat(_toConsumableArray(selectedItems), [product]);
    }
    setAddOnListSelectedItems(selectedItems);
  };

  var _useState7 = useState(''),
      _useState8 = _slicedToArray(_useState7, 2),
      productHandleForModal = _useState8[0],
      setProductHandleForModal = _useState8[1];

  var setActiveProductForAddOnModal = function setActiveProductForAddOnModal(handle) {
    setProductHandleForModal(handle);
  };

  // Shipping Surcharge
  // #TEMPSHIPPINGSURCHARGE (remove after setting up middleware)
  var shippingSurchargeTag = product.tags.includes('data--shipping-surcharge');

  var eligibleForDiscountSnippet = product.tags.includes('data--no_coupon:0');

  var variant_selectors = product.options.map(function (option) {
    return React.createElement(VirtualGiftCardProductVariantSelector, {
      handleOptionChange: handleOptionChange,
      key: option.id,
      option: option,
      selectedOptions: selected.options,
      variants: product.variants.edges,
      productId: product.id
    });
  });

  var klarnaPrice = parseFloat(selected.variant.priceV2.amount.replace('$', ''));

  return React.createElement(
    'div',
    null,
    React.createElement(
      StyledWrapper,
      null,
      React.createElement(
        StyledGrid,
        null,
        React.createElement(ProductGallery, {
          product: product,
          selectedVariant: selected.variant,
          isWishlistProduct: props.isWishlistProduct,
          toggleAccountModal: props.toggleAccountModal
        }),
        React.createElement(ProductHeader, {
          title: product.title,
          selectedVariant: selected.variant,
          nonReturnableVariant: product.tags.includes('NONRETURNABLE'),
          ineligibleForDiscount: product.tags.includes('data--no_coupon:1'),
          productListingSnippet: product.productListingSnippet,
          preorderDate: selected.variant.preorderDate,
          product: product
        }),
        React.createElement(
          DetailsGridDiv,
          null,
          product.variants.edges.length > 1 ? variant_selectors : null,
          React.createElement(VirtualGiftCardProductForm, {
            tags: product.tags,
            virtualGiftCardValues: userInput,
            handleMonogramInput: handleChange,
            virtualGiftCardError: virtualGiftCardError,
            handleVirtualGiftCardError: handleVirtualGiftCardError,
            virtualGiftCardSelectOption: selectOption,
            setVirtualGiftCardSelectOption: setSelectOption
          }),
          props.pdpDiscountSnippet.display && selected.variant.availableForSale && eligibleForDiscountSnippet && React.createElement(ProductDiscountSnippet, {
            selectedVariant: selected.variant,
            pdpDiscountSnippet: props.pdpDiscountSnippet,
            pdpCollectionDiscount: props.pdpCollectionDiscount
          }),
          addOnListTag && React.createElement(ProductAddOnList, {
            addOnListTag: addOnListTag,
            selectedOptions: selected.options,
            handleSetAddOnListSelectedItems: handleSetAddOnListSelectedItems,
            setActiveProductForAddOnModal: setActiveProductForAddOnModal
          }),
          React.createElement(ProductMessaging, {
            selectedVariant: selected.variant,
            selectedVariantInventory: variantInventoryData && variantInventoryData[selected.variant.title],
            lowStockThreshold: props.lowStockThreshold,
            product: product
          }),
          React.createElement(AddToCartBtn, {
            selectedVariantId: selected.variant.id,
            variantExists: variantExists,
            selectedVariantQuantity: selectedVariantQuantity,
            addVariantToCart: props.addVariantToCart,
            selectedVariantAvailable: selected.variant.availableForSale,
            product: product,
            btnStyle: 'PRODUCT',
            setAtcClicked: setAtcClicked,
            isMonogramProduct: product.tags.includes('use-monogram-field'),
            addOnListSelectedItems: addOnListSelectedItems,
            shippingSurcharge: shippingSurchargeTag // #TEMPSHIPPINGSURCHARGE
            , virtualGiftCardValues: userInput,
            handleVirtualGiftCardError: handleVirtualGiftCardError,
            virtualGiftCardSelectOption: selectOption,
            setInitialStateVirtualGiftCardForm: setInitialStateVirtualGiftCardForm,
            ineligibleForDiscount: product.tags.includes('data--no_coupon:1'),
            selectedVariant: selected.variant,
            isWishlistProduct: props.isWishlistProduct,
            toggleAccountModal: props.toggleAccountModal
          }),
          klarnaPrice > 35 && React.createElement(KlarnaPlacement, { price: klarnaPrice }),
          React.createElement(ProductAccordion, {
            tags: product.tags,
            vendor: product.vendor,
            customReturnPolicy: product.returnPolicy,
            shipLaterEnabled: props.shipLaterEnabled,
            preorderDate: selected.variant.preorderDate,
            shippingTimes: props.shippingTimes,
            pdpReturnCopy: props.pdpReturnCopy,
            product: product,
            material: selected.variant.material,
            dimension: selected.variant.dimension,
            selectedVariant: selected.variant
          })
        )
      ),
      React.createElement(
        Suspense,
        { fallback: _ref },
        React.createElement(
          StyledSliderWrapper,
          null,
          React.createElement(DySlider, {
            addVariantToCart: props.addVariantToCart,
            checkout: props.checkout,
            dySlug: 'product-sidebar'
          })
        )
      ),
      React.createElement(
        Suspense,
        { fallback: _ref2 },
        React.createElement(
          StyledSliderWrapper,
          null,
          React.createElement(DySlider, {
            addVariantToCart: props.addVariantToCart,
            checkout: props.checkout,
            dySlug: 'product-full-width'
          })
        )
      ),
      _ref3,
      addOnModalTag && React.createElement(ProductAddOnModal, {
        addVariantToCart: props.addVariantToCart,
        selectedOptions: selected.options,
        checkout: props.checkout,
        atcClicked: atcClicked,
        addOnModalTag: addOnModalTag // addOnModalTag ex: data--add_on:duvet-insert
      }),
      addOnListTag && React.createElement(ProductAddOnListModal, {
        addOnClicked: productHandleForModal !== '',
        productHandle: productHandleForModal,
        setProductHandleForModal: setProductHandleForModal,
        selected: selected
      })
    ),
    ReactDOM.createPortal(React.createElement(
      Suspense,
      { fallback: _ref4 },
      React.createElement(DySlider, {
        addVariantToCart: props.addVariantToCart,
        checkout: props.checkout,
        dySlug: 'product-below-reviews'
      })
    ), document.getElementById('pdp-slider-reviews'))
  );
};

VirtualGiftCardProduct.propTypes = {
  addVariantToCart: PropTypes.func.isRequired,
  checkout: PropTypes.object.isRequired,
  product: PropTypes.object.isRequired,
  pdpDiscountSnippet: PropTypes.object.isRequired,
  isWishlistProduct: PropTypes.bool.isRequired,
  shipLaterEnabled: PropTypes.bool,
  toggleAccountModal: PropTypes.func.isRequired,
  pdpAccordionBnslCopy: PropTypes.string,
  pdpReturnCopy: PropTypes.string,
  shippingTimes: PropTypes.object,
  lowStockThreshold: PropTypes.string,
  pdpCollectionDiscount: PropTypes.object
};

export default VirtualGiftCardProduct;